<template>
  <div class="positionfixed">
    <Header></Header>
  <div class="pc_all FreeCreation">
    <div class="pc_all_content">
      <!-- 导航部分 -->
      <div
        class="FreeCreationNav animate__animated animate__fadeInDown"
        style="animation-delay: 0.2s"
      >
        <div class="FreeCreationNav_btn">
          <router-link to="/ailogo/FreeCreation/FreeCreation" class="FreeCreationNav_list font20">
            <span class="iconfont icon-chuangzuozhezhongxin"></span>自由创作
          </router-link>
          <router-link to="/ailogo/LetterLogo/LetterLogo" class="FreeCreationNav_list font20 active">
            <span class="iconfont icon-fa-buysellads"></span>字母LOGO
          </router-link>
          <router-link to="/ailogo/SameCreation/SameCreation" class="FreeCreationNav_list font20">
            <span class="iconfont icon-AItongkuan"></span>同款创作
          </router-link>
        </div>
      </div>

      <!-- 风格和配色选择部分 -->
      <div class="StyleColor">
        <div
          class="StyleColor_title font20 animate__animated animate__fadeInDown"
          style="animation-delay: 0.4s"
        >
          选择您喜欢的配色
        </div>

        <!-- 配色选择列表 -->
        <div class="StyleColor_color">
          <div
            class="StyleColor_color_list animate__animated animate__fadeInDown"
            style="animation-delay: 0.6s"
            v-for="(colorList, index) in colorLists"
            :key="'colorList-' + index"
            :class="{ active: selectedColorList === index }"
            @click="selectColorList(index)"
          >
            <div class="color_list_top">
              <div class="list_top_li" v-for="n in 5" :key="'color-' + n"></div>
            </div>
            <div class="color_list_title font16">{{ colorList.title }}</div>
          </div>
        </div>

        <!-- 其他颜色输入部分 -->
        <div
          class="StyleColor_bottomcolor animate__animated animate__fadeInDown"
          style="animation-delay: 0.8s"
          :class="{ active: otherColorInput }"
        >
          <div class="StyleColor_bottomcolor_left font18"><span></span>其他：</div>
          <div class="StyleColor_bottomcolor_right">
            <input
              type="text"
              placeholder="请输入您喜欢的颜色（例如：棕色）"
              class="font20"
              v-model="otherColorInput"
              @input="handleInput"
            />
          </div>
        </div>
      </div>

      <!-- 按钮部分 -->
      <div class="Btn animate__animated animate__fadeInDown" style="animation-delay: 1s">
        <div class="Btn_prev font20" @click="goBack">
          <span class="iconfont icon-xiangyou"></span>上一步
        </div>
        <div class="Btn_next font20" :class="{ active: isBtnNextActive }" @click="goToFreeCreation">
          <div class="form_btn_po">继续<span class="iconfont icon-xiangyou"></span></div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Header from '@c/header/header'

export default {
  data() {
    return {
      selectedColorList: null, // 当前选中的配色列表索引
      otherColorInput: '', // 其他颜色输入内容
      colorLists: [
        // 配色列表数据
        { title: '智能推荐' },
        { title: '暖色系' },
        { title: '冷色系' },
        { title: '明亮色彩' },
        { title: '温暖柔和' },
        { title: '敏捷利落' },
        { title: '炫酷黑白' }
      ]
    }
  },
  components: {
    Header
  },
  methods: {
    // 选择配色列表
    selectColorList(index) {
      // 当输入其他颜色时，清除配色列表的选中
      if (this.otherColorInput.trim() !== '') {
        this.otherColorInput = ''
      }
      this.selectedColorList = index
    },
    // 处理其他颜色输入
    handleInput() {
      if (this.otherColorInput.trim() !== '') {
        // 输入内容时，取消配色列表的选中
        this.selectedColorList = null
      }
    },
    goToFreeCreation() {
      if (this.isBtnNextActive) {
        this.$router.push('/ailogo/LetterLogo/LetterLogoKeyword')
      }
    },
    goBack() {
      this.$router.back() // 或者使用 this.$router.go(-1) 返回前一个页面
    }
  },
  computed: {
    // 计算“继续”按钮是否激活
    isBtnNextActive() {
      return this.selectedColorList !== null || this.otherColorInput.trim() !== ''
    }
  }
}
</script>


<style>
@import "LetterLogo.css";
</style>
